import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomButton from 'shared/custom-button/CustomButton';
import { colors } from 'app/providers/theme/colors-type';
import styles from 'features/mite-policy/step-2/StepTwo.module.css';
import InfoIcon from '@mui/icons-material/Info';
import { IStepTwo } from 'entities/mite-policy/step-2/types/step-two-inerface';
import { Link } from 'react-router-dom';
import AppStoreImg from 'shared/assets/AppStoreImg';
import GooglePlayImg from 'shared/assets/GooglePlayImg';

interface FieldValidationStepProps {
    formState: IStepTwo;
    formatPhone: (phone: string) => string;
    handleNext: () => void;
    handleBack: () => void;
    windowWidth: number;
}

export const FieldValidationStep: React.FC<FieldValidationStepProps> = ({
    formState,
    formatPhone,
    handleNext,
    handleBack,
    windowWidth
}) => {
    return (
        <Box>
            <Box className={styles.titleBox}>
                <h4>Проверка полей</h4>
                <p>Проверьте введенные данные перед оформлением</p>
            </Box>
            <Box>
                <Box className={styles.insuranceBox}>
                    <Box className={styles.insuranceTitle}>
                        <h4>Страхователь</h4>
                    </Box>
                    <Box className={styles.insuranceItem}>
                        <span>ФИО</span>
                        <p>{formState.LastName} {formState.FirstName} {formState.MiddleName}</p>
                    </Box>
                    <Box className={styles.insuranceItem}>
                        <span>Дата рождения</span>
                        <p>{formState.BirthDate}</p>
                    </Box>
                    <Box className={styles.insuranceItem}>
                        <span>Почта</span>
                        <p>{formState.Email}</p>
                    </Box>
                    <Box className={styles.insuranceItem}>
                        <span>Телефон</span>
                        <p>{formatPhone(formState.Phone)}</p>
                    </Box>
                </Box>
                <Box className={styles.insurandBox}>
                    {formState.InsuredList.map((insured, index) => (
                        <Box key={index} className={styles.insurandItem}>
                            <span>Застрахованный {index + 1}</span>
                            <p>{insured.Fio}, {insured.BirthDate}</p>
                        </Box>
                    ))}
                </Box>
                <Box className={styles.colorBox}>
                    <span className={styles.icon}><InfoIcon /></span>
                    <p>После оплаты, мы отправим полис на почту <span>{formState.Email}</span></p>
                </Box>

                {windowWidth <= 700 ? (
                    <>
                        <Box className={styles.infoText}>
                            <p>Полис также будет доступен в приложении</p>
                            <span>Ю-Здоровье</span>
                        </Box>
                        <Box className={styles.linkAppBox}>
                            <a
                                href="https://apps.apple.com/ru/app/%D1%8E-%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5/id6744051740?l"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <AppStoreImg />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.skgaidemobile"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <GooglePlayImg />
                            </a>
                        </Box>
                    </>

                ) : (
                    <>
                        <Box className={styles.infoText}>
                            <p>Полис также будет доступен в приложении <span>Ю-Здоровье</span></p>
                        </Box>

                    </>

                )}


            </Box>
            <Box className={styles.btnBoxNext}>
                <CustomButton
                    title="Назад"
                    handleClick={handleBack}
                    textColor={colors.primary}
                    backgroundColor="none"
                    width="150px"
                    gap="10px"
                    borderRadius="4px"
                    padding="3px"
                    border="none"
                />
                <CustomButton
                    title="К оплате"
                    handleClick={handleNext}
                    textColor="white"
                    backgroundColor={colors.primary}
                    width="150px"
                    gap="10px"
                    borderRadius="4px"
                    padding="3px"
                />
            </Box>
        </Box>
    );
};
